/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".img-circle{border-radius:50%;height:20px}.subjects .title{padding:10px;font-weight:700;border-bottom:1px solid #122f4c}.subjects .search{padding:10px}.scrollable{overflow-y:scroll}"];
export { styles as styles };
